const pickFields = (fields, obj) => fields.reduce((acc, field) => {
  if (Object.prototype.hasOwnProperty.call(obj, field)) {
    acc[field] = obj[field];
  }
  return acc;
}, {});
export {
  pickFields as p
};
